module.exports = __webpack_public_path__ + "img/google.122369bb.svg";